// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0c4f857b","461":"bdc0daa0"}[chunkId] + ".chunk.js";
};